module.exports = __webpack_public_path__ + "media/images/official/icon_circle_check-fd1d42bea1411b024b45128c7dba1a44.svg";